import {Component, Injector} from "@angular/core";
import {InventorySearchModel} from "../inventory-search.model";
import {InventorySearchPageComponent} from "../inventory-search-page/inventory-search-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-inventory-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(InventorySearchModel),
        registerSearchControl(InventoryMultiSelectSearchControlComponent)
    ]
})
export class InventoryMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<InventorySearchModel> {
    constructor(model: InventorySearchModel, injector: Injector) {
        super(model, injector, "inventoryId", "name");
        this.extendedSearchComponent = InventorySearchPageComponent;
    }
}
